<router-outlet></router-outlet>

<div id="ohaLoader">
    <div class="loader"></div>
    <div class="loader-text">{{ 'COMMON_LABEL.LOADING' | translate }}</div>
</div> 
